import { RouteRecordRaw } from 'vue-router'
import userSettingsRoutes from './userSettings'
import backOfficeRoutes from './backOffice'

export default <RouteRecordRaw[]>[...backOfficeRoutes, ...userSettingsRoutes]
